import {FieldType} from "../../fields3/field-type";
import FieldsCollection from "../../fields3/collection/base/fields-collection";
import {EntityType} from "../../gd/const/item";
import FieldString from "../../fields3/generic/string/string";
import FieldUser from "../../fields3/generic/user/user";
import FieldDate from "../../fields3/generic/datetime/date/date";
import FieldText from "../../fields3/generic/text/text";
import FieldMoment from "../../fields3/generic/datetime/moment/moment";
import FieldProjectPath from "../../fields3/generic/project-path/project-path";


const baseConfig = [
    {
        fieldId : 'name',
        type    : FieldType.STRING,
        label   : 'Name'
    },

    {
        fieldId : 'description',
        type    : FieldType.TEXT,
        label   : 'Description'
    },

    {
        fieldId : 'createdByUserId',
        type    : FieldType.USER,
        label   : 'Created by'
    },

    {
        fieldId : 'date',
        type    : FieldType.DATE,
        label   : 'Date'
    },

    {
        fieldId : 'projectId',
        type    : FieldType.PROJECT_PATH,
        label   : 'Project'
    },

    {
        fieldId : 'momentCreated',
        type    : FieldType.MOMENT,
        label   : 'Created on'
    },
]


export default class SavedViewsFields extends FieldsCollection {

    constructor() {
        const fieldsConfig = baseConfig;
        super(fieldsConfig, EntityType.DYNAMIC_MODEL);
    }

    get type()              { return this.get('type') as FieldString }
    get name()              { return this.get('name') as FieldString }
    get description()       { return this.get('description') as FieldText }
    get createdByUserId()   { return this.get('createdByUserId') as FieldUser }
    get date()              { return this.get('date') as FieldDate }
    get momentCreated()     { return this.get('momentCreated') as FieldMoment }
    get project()           { return this.get('projectId') as FieldProjectPath }

}
